// src/constants.js


export const BASE_URL = process.env.REACT_APP_BASE_URL

export const getLogInUrl = () => {
  return  `${BASE_URL}/auth/login`// Default URL
};

export const getFirstTimePwdReset = () => {
  return  `${BASE_URL}/auth/first-time/pwd-reset`// Default URL
};


export const getBulkUploadUrl = () => {
  return  `${BASE_URL}/users/bulk`// Default URL
};

export const getAllUsersUrl = () => {
  return  `${BASE_URL}/users`// Default URL
};

export const getDeleteUserUrl = () => {
  return  `${BASE_URL}/users/update-status`// Default URL
};

export const getMemoCreateUrl = () => {
  return  `${BASE_URL}/memo/storeWatchTime`// Default URL
};

export const getMemoListUrl = () => {
  return  `${BASE_URL}/memo/watchtimeList`// Default URL
};

export const getSecurityQusUrl = (employeeId) => {
  return  `${BASE_URL}/auth/getSecurityQuestion/${employeeId}`// Default URL
};

export const getForgotPwdUrl = () => {
  return  `${BASE_URL}/auth/resetPassword`// Default URL
};

export const getChangePwdUrl = () => {
  return  `${BASE_URL}/users/change-pwd-reset`// Default URL
};

export const getUserDataUrl = (employeeId) => {
  return  `${BASE_URL}/users/${employeeId}`// Default URL
};

export const getSaveUserDataUrl = (employeeId) => {
  return  `${BASE_URL}/users/save-module-access/${employeeId}`// Default URL
};

export const getUserSessionUrl = (employeeId) => {
  return  `${BASE_URL}/users/check-session/${employeeId}`// Default URL
};




